import { Action, createReducer, on } from '@ngrx/store';

import * as BookmarkProblemsActions from '../actions/bookmark-problems.actions';
import { BookmarkProblemsCollection } from '../models/bookmark-problem';

export const bookmarkProblemsFeatureKey = 'bookmarkProblems';

export interface State {
  bookmarkProblems: BookmarkProblemsCollection[] | null;
  bookmarkProblemToDelete: BookmarkProblemsCollection | null;
}

export const initialState: State = {
  bookmarkProblems: null,
  bookmarkProblemToDelete: null
};

const BookmarkProblemsReducer = createReducer(
  initialState,

  // Find Bookmark Problems -----------------------------------------------------------------
  on(BookmarkProblemsActions.findBookmarkProblemsSuccess, (state, { bookmarkProblems }) => ({
    ...state,
    bookmarkProblems
  })),
  on(BookmarkProblemsActions.initializeFindBookmarkProblemsState, state => {
    const next: State = { ...state, bookmarkProblems: null };
    return next;
  }),

  // お気に入りリストに問題を登録する (ステートの操作) -------------------------------------------
  on(BookmarkProblemsActions.addProblem, (state, { tempId, collectionData }) => {
    const next: State = {
      ...state,
      bookmarkProblems: [...state.bookmarkProblems, { id: tempId, ...collectionData }]
    };
    return next;
  }),

  // お気に入りリストへの問題の登録が成功した際、Idを上書きする (ステートの操作) ---------------------
  on(BookmarkProblemsActions.updateBookmarkProblemsId, (state, { tempId, realId }) => ({
    ...state,
    bookmarkProblems: state.bookmarkProblems.map(p => (p.id === tempId ? { ...p, id: realId } : p))
  })),

  // お気に入りリストから問題を削除する (ステートの操作) -------------------------------------------
  on(BookmarkProblemsActions.deleteProblem, (state, { listId, problemId }) => {
    const next: State = {
      ...state,
      bookmarkProblems: state.bookmarkProblems.filter(p => p.bookmarkProblemListId !== listId || p.problemId !== problemId),
      bookmarkProblemToDelete: state.bookmarkProblems.find(p => p.bookmarkProblemListId === listId && p.problemId === problemId)
    };
    return next;
  })
);

export function reducer(state: State | undefined, action: Action) {
  return BookmarkProblemsReducer(state, action);
}
